import React from "react";
import Link from "gatsby-link";
import { Box } from "rebass";
import styled, { withTheme } from "styled-components";
import componentQueries from "react-component-queries";
import { compose } from "redux";
import Grid from "./grid";
import Image from "./image";
import { formatDate } from "../utils";

const Caption = styled(Box)`
  display: flex;
  div:first-child {
    margin-right: 1rem;
    font-weight: bold;
  }
`;

const componentQuery = ({ width }, props) => {
  const { orientation } = props.theme;
  const { overrideColumns } = props;
  const layoutProps = (function mapWidthToLayoutProps() {
    const dFault = {
      columns: overrideColumns || orientation.vertical ? 1 : 2,
      spacing: orientation.vertical ? 1 : 5,
      mb: orientation.vertical ? 10 : 5,
      image: {
        ratio: orientation.vertical ? 1 / 2 : 2 / 3
      },
      caption: {
        mt: 8,
        f: orientation.vertical ? 11 : 9
      }
    };

    if (width > 1500) {
      return {
        ...dFault,
        image: {
          ratio: 2 / 3
        },
        columns: overrideColumns || orientation.vertical ? 2 : 4,
        spacing: orientation.vertical ? 2 : 1,
        mb: orientation.vertical ? 3 : 2,
        caption: {
          mt: 2,
          f: orientation.vertical ? 6 : 5
        }
      };
    }

    if (width > 1000) {
      return {
        ...dFault,
        image: {
          ratio: 2 / 3
        },
        columns: overrideColumns || orientation.vertical ? 2 : 3,
        spacing: orientation.vertical ? 3 : 2,
        mb: orientation.vertical ? 3 : 2,
        caption: {
          mt: 3,
          f: orientation.vertical ? 7 : 6
        }
      };
    }

    if (width > 700) {
      return {
        ...dFault,
        image: {
          ratio: 2 / 3
        },
        columns: orientation.vertical ? 2 : 3,
        spacing: orientation.vertical ? 3 : 2,
        mb: orientation.vertical ? 3 : 1,
        caption: {
          mt: 5,
          f: orientation.vertical ? 8 : 7
        }
      };
    }

    if (width > 500) {
      return {
        ...dFault,
        caption: {
          mt: 6,
          f: orientation.vertical ? 9 : 8
        }
      };
    }

    return dFault;
  })();

  return {
    layoutProps
  };
};

export default compose(
  withTheme,
  componentQueries(componentQuery)
)(({ projects, onProjectClick, layoutProps }) => {
  const { columns, f, mb, spacing } = layoutProps;
  const projectThumbnails = projects.map(project => {
    console.log(project.metadata);
    const dates = project.metadata
      .filter(md => md.itemType === "date")
      .map(({ value: date }) => formatDate(date))
      .join(" – ");
    return (
      <Box onClick={onProjectClick} key={project.slug} mb={mb}>
        <Link to={`/projecten/${project.slug}`}>
          <Image
            background
            ratio={layoutProps.image.ratio}
            file={project.bannerImage}
          />
        </Link>
        <Caption {...layoutProps.caption}>
          <div>{project.title}</div>
          <div>{dates}</div>
        </Caption>
      </Box>
    );
  });

  return (
    <Grid items={projectThumbnails} spacing={spacing} f={f} columns={columns} />
  );
});



// WEBPACK FOOTER //
// ./src/components/projectgrid.js